import clsx from 'clsx';

const ResponsiveTableFrame = ({
  children,
  pagination,
  className,
  tableClassName,
  paginationClassName,
  scrollLabel = 'Scrollable table',
}) => (
  <div className={clsx('w-full min-w-0', className)}>
    <div
      className={clsx(
        'w-full min-w-0 overflow-x-auto overscroll-x-contain',
        tableClassName
      )}
      aria-label={scrollLabel}
      role="region"
      tabIndex={0}
    >
      {children}
    </div>
    {pagination && (
      <div
        className={clsx(
          'w-full min-w-0 overflow-x-auto pt-3 sm:overflow-x-visible',
          paginationClassName
        )}
      >
        {pagination}
      </div>
    )}
  </div>
);

export default ResponsiveTableFrame;
